// extracted by mini-css-extract-plugin
export default {"cardList__more":"best_cardList__more__ApGAd"};